<section class="section-planos" [ngStyle]="styles" *ngIf="items.length > 0">
    <div class="container wrapper-planos py-4" [ngClass]="classesAlign">
        <div class="wrapper-planos pb-3" [ngClass]="classesAlign">
            <h1 class="title-planos">{{title}}</h1>
            <p *ngIf="showSubtitle" class="subtitle-planos">{{subtitle}}</p>
        </div>
        <app-carousel-plans 
            [items]="items" 
            [styles]="styles"
            [defaultButtonOptions]="buttonOptionsCard"
            [highlightButtonOptions]="buttonOptionsCardSpecial"
            (carouselResponse)="carouselResponse($event)">
        </app-carousel-plans>
    </div>
</section>

<!-- Modal de Seleção de Planos -->
<app-modal-plan-selection
    [isVisible]="showModal"
    [categories]="modalCategories"
    [initialCategoryIndex]="selectedCategoryIndex"
    [operationType]="'NEW'"
    (close)="onCloseModal()"
    (selectPlan)="onSelectPlan($event)">
</app-modal-plan-selection>
